import React, { useState, useEffect } from 'react';
import HeroBanner from '../components/common/HeroBanner/HeroBanner';
import { sendShipmentEmail } from '../utils/emailService';
import './Contact.css';

const Contact = () => {
  useEffect(() => {
    document.title = 'NEST | Contact';
    // Scroll to contact form if hash is present
    if (window.location.hash === '#contact-form') {
      const element = document.getElementById('contact-form');
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  // Auto-dismiss success message after 2.5 seconds
  useEffect(() => {
    if (message.text && message.type === 'success') {
      const timer = setTimeout(() => setMessage({ type: '', text: '' }), 2500);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [message]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    // You can create a separate email service function for contact form
    // For now, using the same service with adapted data
    const emailData = {
      pickupLocation: formData.name,
      dropoffLocation: formData.subject,
      pickupDate: '',
      pickupTime: '',
      email: formData.email,
      phone: formData.message
    };

    const result = await sendShipmentEmail(emailData);

    if (result.success) {
      setMessage({ type: 'success', text: 'Message sent successfully!' });
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } else {
      setMessage({ type: 'error', text: `Failed to send message: ${result.error?.text || 'Unknown error'}` });
    }

    setLoading(false);
  };

  return (
    <div className="contact-page">
      <HeroBanner 
        title="Contact us" 
        breadcrumbs={['Contact']}
      />
      <section className="ftco-section contact-section">
        <div className="container">
          <div className="row d-flex mb-5 contact-info justify-content-center">
            <div className="col-md-8">
              <div className="row mb-5">
                <div className="col-md-4 text-center py-4">
                  <div className="icon">
                    <span className="icon-map-o"></span>
                  </div>
                  <p><span>Address:</span> Nest Auto Transport Inc. <br/> 13151 Emily Rd Suite # 210-D Dallas TX 75240</p>
                </div>
                <div className="col-md-4 text-center border-height py-4">
                  <div className="icon">
                    <span className="icon-mobile-phone"></span>
                  </div>
                  <p><span>Phone:</span> <a href="tel://+1888512NEST">+1 (888) 512-NEST</a></p>
                </div>
                <div className="col-md-4 text-center py-4">
                  <div className="icon">
                    <span className="icon-envelope-o"></span>
                  </div>
                  <p><span>Email:</span> <a href="mailto:info@nestautotransport.com">info@nestautotransport.com</a></p>
                </div>
              </div>
            </div>
          </div>
          <div className="row block-9 justify-content-center mb-5" id="contact-form">
            <div className="col-md-8 mb-md-5">
              <h2 className="text-center">If you have any questions <br/>please do not hesitate to send us a message</h2>
              <form onSubmit={handleSubmit} className="bg-light p-5 contact-form">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your Email"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Subject"
                    required
                  />
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    cols="30"
                    rows="7"
                    className="form-control"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Message"
                    required
                  ></textarea>
                </div>
                {message.text && (
                  <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-danger'}`}>
                    {message.text}
                  </div>
                )}
                <div className="form-group">
                  <input
                    type="submit"
                    value={loading ? 'Sending...' : 'Send Message'}
                    className="btn btn-primary py-3 px-5"
                    disabled={loading}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;


